﻿export interface IProductOwner {
    productId: number,
    initials: string,
    name: string,
    isActive: boolean
}
